<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'

const emit = defineEmits(['pick'])

const countdown = ref(3)
let timer: number | null = null

const startTimer = () => {
  timer = window.setInterval(() => {
    if (countdown.value > 1) {
      countdown.value--
    } else {
      handlePick()
    }
  }, 1000)
}

const handlePick = () => {
  if (timer) clearInterval(timer)
  emit('pick')
}

onMounted(() => {
  startTimer()
})

onUnmounted(() => {
  if (timer) clearInterval(timer)
})
</script>

<template>
  <div class="gift-selection-overlay">
    <div class="content">
      <h2 class="urdu-title">ریفر کریں اور جیتیں</h2>
      <h1 class="reward-title">Rs 2000 مفت کیش</h1>

      <div class="boxes-grid">
        <div v-for="i in 4" :key="i" class="box-item cursor-pointer" @click="handlePick">
          <img src="@/assets/activity/pinduo/BOX1.webp" class="box-img pulse" />
        </div>
      </div>

      <div class="timer-guide">
        اپنا انعام جمع کرنے کے لیے ٹیپ کریں ({{ countdown }}s)
      </div>
    </div>
  </div>
</template>

<style scoped>
.gift-selection-overlay {
  position: fixed;
  inset: 0;
  background: radial-gradient(circle, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.95) 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  color: white;
  text-align: center;
}

.urdu-title {
  font-size: 1.6rem;
  margin-bottom: 5px;
  color: #ffda6b;
}

.reward-title {
  font-size: 2.2rem;
  font-weight: bold;
  margin-bottom: 40px;
  color: #fff;
}

.boxes-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  margin-bottom: 40px;
}

.box-item {
  width: 140px;
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box-img {
  width: 100%;
  height: auto;
}

.timer-guide {
  font-size: 1rem;
  color: #aaa;
  margin-top: 20px;
}

.pulse {
  animation: pulse-animation 2s infinite;
}

@keyframes pulse-animation {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}
</style>
